import { Button, Card, Heading, Paragraph } from '@tmov/design-system';
import { Tokens } from '@tmov/design-system/theme/types';
import React, { useCallback, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ActionButtons, Container, Description, Header } from './styles';

export const Finished = () => {
  const history = useHistory();
  const location = useLocation();

  const handleGoToNewCotacaoPage = () => {
    history.push({ pathname: '/cotacao/criar' });
  };

  const handleGoToListagem = useCallback(() => {
    history.push({ pathname: '/cotacao' });
  }, [history]);

  useLayoutEffect(() => {
    if (!location.state?.rota) {
      handleGoToListagem();
    }
  }, [handleGoToListagem, location.state]);

  return (
    <Container>
      <Card width="100%">
        <Header>
          <Heading
            variant="h3"
            style={{ color: Tokens.eixods.colors.brand.primary[100] }}
          >
            Cotação criada com sucesso!
          </Heading>
          <Paragraph variant="p2">{location.state?.rota}</Paragraph>
        </Header>
        <Description>
          <Paragraph variant="p1" fontWeight="semibold">
            A cotação iniciará automaticamente na data definida.
          </Paragraph>
          <Paragraph variant="p2">
            Você poderá acompanhar o andamento das propostas acessando os
            detalhes do BID.
          </Paragraph>
        </Description>
        <ActionButtons>
          <Button
            onClick={handleGoToNewCotacaoPage}
            style={{ width: 136, height: 36 }}
          >
            Nova cotação
          </Button>
          <Button
            onClick={handleGoToListagem}
            variant="outlined"
            style={{ width: 136, height: 36 }}
          >
            Ver cotações
          </Button>
        </ActionButtons>
      </Card>
    </Container>
  );
};
